import React, { useState } from 'react';
import { Link, Paper, Typography } from '@material-ui/core';
import { App } from '../../../../models/app';
import { useTranslation } from 'react-i18next';
import { VersionHistoryModal } from './VersionHistoryModal';
import styles from './styles.module.scss';
import ctx from 'classnames';

interface ComponentProps {
  app: App;
}

export const AppsVersion: React.FC<ComponentProps> = ({ app }): JSX.Element => {
  const { t } = useTranslation();
  const { androidVersion } = app;
  const [versionHistoryModal, setVersionHistoryModal] = useState(false);

  const checkModalState = () => {
    setVersionHistoryModal(true);
  };

  return (
    <>
      <Paper square className={styles.appVersionWrapper}>
        <h4>
          {t('app_details.whats_new')}
        </h4>
        <Typography gutterBottom>
          {t('app_details.latest_version', {
            version: androidVersion?.versionName,
          })}
        </Typography>
        <Link href="#" onClick={checkModalState}><p className={ctx("captionText", styles.versionHistoryLink)}>{t('app_details.view_version_history')}</p></Link>
      </Paper>
      {versionHistoryModal && <VersionHistoryModal app={app} onClose={() => setVersionHistoryModal(false)} />}
    </>
  );
};
